import checkPermission from "@/utils/permission";
export default {
  inserted: function inserted(el, binding, vnode) {
    var value = binding.value;
    if (!value) {
      console.error("need permission value ! like v-permission=\"'button serial number'\" ", vnode);
      throw new Error("need permission value ! like v-permission=\"'button serial number'\" ");
    }
    var path = vnode.context.$route.path;
    var hasPermission = checkPermission(value, path);
    if (!hasPermission) {
      if (el.tagName !== "BUTTON") {
        var domTree = el.getElementsByTagName("*");
        var _loop = function _loop() {
          var item = domTree[i];
          if (["INPUT", "TEXTAREA"].some(function (p) {
            return p === item.tagName;
          })) {
            item.setAttribute("disabled", "disabled");
            item.parentNode.className += " is-disabled";
            if (item.parentNode.parentNode.className.indexOf("el-cascader") !== -1 || item.parentNode.parentNode.className.indexOf("el-select") !== -1) {
              item.parentNode.parentNode.style.pointerEvents = "none";
              item.parentNode.parentNode.style.cursor = "not-allowed";
              item.parentNode.removeChild(item.nextElementSibling);
            }
          }
        };
        for (var i = 0; i < domTree.length; i++) {
          _loop();
        }
      } else {
        el.style.display = "none";
        el.parentNode && el.parentNode.removeChild(el);
        // el.setAttribute("disabled", "disabled")
        // el.className += " is-disabled"
      }
    }
  }
};

export { checkPermission };